import React from "react";
import { map } from "lodash";
import { Text, OrientationBloc } from "../../../../../components";
import {
  OrientationContainer,
  SubTitleContainer,
  TitleContainer,
  TextContainer,
} from "./styled-components";
import { ReactComponent as BookIcon } from "../../../../../assets/icons/book.svg";
import { ReactComponent as EstablishmentIcon } from "../../../../../assets/icons/establishment.svg";

const AlerteNegativeResponse = ({ data }: any) => {
  const options = [
    {
      icon: <EstablishmentIcon />,
      title: data.autority,
      description: (
        <TextContainer>
          <div>
            {map(data.address, (field: string) => (
              <Text>{field}</Text>
            ))}
          </div>
          <Text color="blue">
            Site internet :{" "}
            <a href={data.site.href} target="_blank" rel="noreferrer">
              {data.site.name}
            </a>
          </Text>
          {data.email && (
            <Text color="blue">
              Adresse email :{" "}
              <a
                href={`mailto:${data.email.href}`}
                target="_blank"
                rel="noreferrer"
              >
                {data.email.name}
              </a>
            </Text>
          )}
          {data.phone && (
            <Text color="blue">
              Téléphone :{" "}
              <a
                href={`tel:${data.phone.href}`}
                target="_blank"
                rel="noreferrer"
              >
                {data.phone.name}
              </a>
            </Text>
          )}
        </TextContainer>
      ),
    },

    {
      icon: <BookIcon />,
      title: data.article2 ? "Articles de loi" : "Article de loi",
      description: (
        <>
          <Text>
            <a href={data.article.href} target="_blank" rel="noreferrer">
              {data.article.name}
            </a>
          </Text>
          {data.article2 && (
            <Text>
              <a href={data.article2.href} target="_blank" rel="noreferrer">
                {data.article2.name}
              </a>
            </Text>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <TitleContainer>
        <Text size="40px" weight={700} lineHeight="52px" align="center">
          <span>Une autre autorité est compétente</span>
          <br />
          pour traiter votre alerte
        </Text>
      </TitleContainer>
      <SubTitleContainer>
        <Text size="18px" align="center" color="grey400">
          Le Défenseur des droits ne peut pas traiter votre alerte. Cependant,
          voici le nom d’un organisme qui peut peut-être vous aider. En cas de
          doute, nous pouvons vous aider dans vos démarches.
        </Text>
      </SubTitleContainer>
      <OrientationContainer>
        <OrientationBloc options={options} />
      </OrientationContainer>
    </>
  );
};

export default AlerteNegativeResponse;
